export const limits = {
  INSIDE_SUBSIDIARY_COUNT: 5,
  OUTSIDE_SUBSIDIARY_COUNT: 5
};

export const MAX_TRADE_LICENSE_NUMBER = 12;
export const MAX_BANK_NAME_LENGTH = 50;
export const ANNUAL_TURNOVER_MAX_LENGTH = 13;
export const PERCENTAGE_MAX_LENGTH = 3;
